import { types as t } from 'mobx-state-tree';

import { abbreviateDate } from '@utils/date';

import { withEnv } from 'models/withEnv';

import { Attachment } from '.';

import { User } from '../users';

export const ApplicationMessage = t
  .model('ApplicationMessage', {
    id: t.identifierNumber,
    user: t.maybeNull(t.reference(t.late(() => User))),
    created: t.maybe(t.string),
    modified: t.maybe(t.string),
    message: t.maybeNull(t.string),
    messageType: t.maybe(t.string),
    attachment: t.maybeNull(t.late(() => Attachment)),
    delivered: t.maybeNull(t.boolean),
    failedReason: t.maybeNull(t.string),
    failedStatus: t.maybeNull(t.frozen()),

    // We compute the attachments in the transformer so we can
    // easily group together attachments with their messages

    attachments: t.array(t.late(() => Attachment)),
  })
  .views(withEnv)
  .views((self) => ({
    get dateDisplay() {
      const date = abbreviateDate(self.created, self.env.lang, 'datetime');
      return date;
    },
  }));
